import { moneyFormat } from "@/helper/format-data";
import { colorByVariant } from "./constants/chart.const";
import { TooltipItem } from "@/types/tooltip-item.type";
import { Variant } from "@/helper/chart/types/chart.type";

type LineChartParam = {
  variant?: Variant;
  colorLine: string;
  symbol?: string;
  xAxis: string[];
};

export const lineChartUtil = ({ variant = "primary", symbol, colorLine, xAxis }: LineChartParam) => ({
  title: {
    textStyle: {
      color: colorByVariant[variant],
      fontSize: 16,
      lineHeight: 24,
    },
  },
  tooltip: {
    trigger: "axis",
    formatter: (params: TooltipItem[]) => {
      return params.reduce((result: string, item: TooltipItem) => {
        const newMarker = item.marker.replace(/10px/g, "6px");
        const valueHtml = `<span class='ml-2.5'>${item.value !== 0 ? moneyFormat(item.value) : 0}</span>`;
        const itemNameHtml = `<span class='font-bold'>${item.axisValue}</span>`;
        return result + newMarker + itemNameHtml + "<br/>" + valueHtml + "<br/>";
      }, "");
    },
    backgroundColor: "#FFFFFF",
    borderWidth: 0,
    textStyle: {
      color: "#8383C7",
      fontSize: 10,
      lineHeight: 18,
      fontWeight: 800,
    },
    extraCssText: "box-shadow: 0px 2px 4px rgba(37, 41, 45, 0.17); border-radius: 6px;",
  },
  axisPointer: {},
  xAxis: {
    type: "category" as const,
    axisTick: {
      show: false,
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: "#25292D",
      },
    },
    axisLabel: {
      margin: 6,
      color: "#555E68",
      fontSize: 11,
      lineHeight: 22,
      formatter: function (value: string, index: number) {
        if (index === 0) {
          return "{firstItem|" + value + "}";
        } else if (index === xAxis.length - 1) {
          return "{lastItem|" + value + "}";
        }
        return "{otherItem|" + value + "}";
      },
      rich: {
        firstItem: {
          align: "left" as const,
        },
        lastItem: {
          align: "right" as const,
        },
        otherItem: {
          align: "center" as const,
        },
      },
    },
    boundaryGap: false,
    data: xAxis,
    offset: 4,
  },
  yAxis: {
    type: "value" as const,
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      color: "#555E68",
      fontSize: 11,
      formatter: (value: number) => {
        if (value >= 1000) {
          return (value / 1000).toFixed(0) + "k";
        }
        return value.toString();
      },
    },
    splitLine: {
      lineStyle: {
        color: "#EEEEEE",
        width: 1,
        type: "solid" as const,
      },
    },
  },
  grid: {
    left: 0,
    right: 30,
    bottom: 0,
    top: 13,
    containLabel: true,
  },
  series: [
    {
      type: "line" as const,
      smooth: true,
      showSymbol: false,
      symbol: symbol,
      symbolSize: [24, 24],
      sampling: "average" as const,
      lineStyle: {
        color: colorLine,
        width: 4,
        cap: "round",
      },
      itemStyle: {
        color: colorLine,
      },
    },
  ],
});
